var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGbp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_483_31638)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.1967,
    height: 24.1967,
    transform: "translate(0.266602 0.90625)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.365 25.1029C19.0467 25.1029 24.4633 19.6863 24.4633 13.0046C24.4633 6.32287 19.0467 0.90625 12.365 0.90625C5.68322 0.90625 0.266602 6.32287 0.266602 13.0046C0.266602 19.6863 5.68322 25.1029 12.365 25.1029Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3648 5.64062L12.7566 6.84616H14.0241L12.9986 7.5912L13.3903 8.79673L12.3648 8.05165L11.3393 8.79673L11.731 7.5912L10.7056 6.84616H11.9731L12.3648 5.64062Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15766 7.79736L8.28716 8.37279L9.18343 7.47656L8.98508 8.72846L10.1145 9.30393L8.86258 9.50223L8.66429 10.7542L8.08881 9.62478L6.83691 9.82312L7.73318 8.92685L7.15766 7.79736Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00073 13.005L6.20627 12.6132V11.3457L6.95126 12.3712L8.15684 11.9795L7.41171 13.005L8.15684 14.0305L6.95126 13.6388L6.20627 14.6642V13.3967L5.00073 13.005Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15766 18.2127L7.73314 17.0832L6.83691 16.1869L8.08886 16.3853L8.66424 15.2559L8.86258 16.5078L10.1145 16.7061L8.98517 17.2816L9.18343 18.5335L8.28716 17.6372L7.15766 18.2127Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3648 20.3689L11.9731 19.1634H10.7056L11.7311 18.4183L11.3393 17.2129L12.3648 17.9579L13.3903 17.2129L12.9986 18.4183L14.0241 19.1634H12.7565L12.3648 20.3689Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5722 18.2127L16.4428 17.6372L15.5465 18.5335L15.7448 17.2815L14.6155 16.7061L15.8674 16.5078L16.0657 15.2559L16.6411 16.3853L17.893 16.1869L16.9967 17.0833L17.5722 18.2127Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.729 13.005L18.5235 13.3967V14.6642L17.7784 13.6387L16.573 14.0305L17.318 13.005L16.573 11.9795L17.7785 12.3712L18.5235 11.3457V12.6133L19.729 13.005Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5722 7.79731L16.9968 8.92681L17.893 9.82308L16.6411 9.62468L16.0657 10.7541L15.8674 9.50219L14.6155 9.30384L15.7448 8.72841L15.5465 7.47656L16.4428 8.37279L17.5722 7.79731Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_483_31638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.1967,
    height: 24.1967,
    fill: "white",
    transform: "translate(0.266602 0.90625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbp);
export default __webpack_public_path__ + "static/media/GBP.e353d98c4ef5fb4054a9fe44b547fe70.svg";
export { ForwardRef as ReactComponent };